import { render, staticRenderFns } from "./CartImage.vue?vue&type=template&id=972231d4&"
import script from "./CartImage.vue?vue&type=script&lang=ts&"
export * from "./CartImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports